var allProductsData = {},
	commonProductsData = {};

function showAppropriateStep() {
	const t = new URLSearchParams(window.location.search);
	let e = t.get("step");
	const o = document.querySelectorAll("section[data-step]");
	if (!e) {
		const a = Array.from(o).find((t => !t.classList.contains("hidden")));
		a && (e = a.dataset.step, t.set("step", e), window.history.replaceState(null, null, "?" + t.toString()))
	}
	localStorage.setItem("current-step", e), o.forEach((a => {
		if (a.dataset.step === e) {
			if (a.classList.remove("hidden"), "color-select" === e) {
				commonProductsData = findAllCommonProducts();
				const a = document.querySelector(".page-step-1"),
					n = document.querySelector(".page-step-2"),
					r = document.querySelector(".page-step-3");
				if (0 === commonProductsData.length) {
					if (n && n.classList.add("hidden"), r && r.classList.add("hidden"), a && a.classList.remove("hidden"), !e) {
						const a = Array.from(o).find((t => !t.classList.contains("hidden")));
						a && (e = a.dataset.step, t.set("step", e), window.history.replaceState(null, null, "?" + t.toString()))
					}
					localStorage.setItem("current-step", "i-wear")
                    showStocknotfoundmessage();
				} else generateHtmlForCommonProducts(), updateDesignCounts(), updateInfopreview(), setupTabButtonClickHandlers(), setupTabSwatchClickHandlers()
			}
		} else a.classList.add("hidden")
	}))
}
function showStocknotfoundmessage() {
  const t = localStorage.getItem("i-wear-product-type"),
		e = localStorage.getItem("partner-wear-product-type"),
		o = localStorage.getItem("i-wear-size-selected"),
		a = localStorage.getItem("partner-wear-size-selected");
    
  let variantSizesDiv = document.querySelector('.page-step-1 .variant_sizes');
  
  if (variantSizesDiv) {
      let existingError = variantSizesDiv.nextElementSibling;
      if (existingError && existingError.classList.contains('error-message-size')) {
        existingError.remove();
      }
  
      let errorMessage = document.createElement('div');
      errorMessage.textContent = `Selected Combination for ${t} - ${o} and ${e} - ${a} are not available, Please select another options`;
      errorMessage.classList.add('error-message-size');
      errorMessage.style.color = 'red';
      errorMessage.style.marginBottom = '15px'; 
  
      variantSizesDiv.insertAdjacentElement('afterend', errorMessage);
      setTimeout(function () {
          errorMessage.remove();
        },5000);
  }
}
function generateHtmlForCommonProducts() {
	let t = "";
	const e = new Set;
	for (const o in commonProductsData) {
		const a = commonProductsData[o],
			n = a.tags || [];
		if (e.has(a.design_name)) continue;
		let r = "";
		n.some((t => "prints" === t.toLowerCase())) && (r += "prints "), n.some((t => "solids" === t.toLowerCase())) && (r += "solids "), n.some((t => "new" === t.toLowerCase())) && (r += "new"), t += `\n            <div class="type_swatch all ${r.trim()}">\n                <button href="#" class="tab-swatch"\n                        data-name="${a.design_name}"\n                        data-type="${a.shape_style}"> \n                    <img src="${a.swatch_icon}">\n                </button>\n            </div>\n        `, e.add(a.design_name)
	}
	const o = document.querySelector(".preview-variant-inner");
	o && (o.innerHTML = t)
}

function setupTabButtonClickHandlers() {
	const t = document.querySelector(".review");
	if (!t) return;
	const e = t.querySelectorAll(".tab-button"),
		o = t.querySelectorAll(".type_swatch");
	e.forEach((t => {
		t.addEventListener("click", (function() {
			e.forEach((t => t.classList.remove("active"))), this.classList.add("active");
			const t = this.getAttribute("data-name"); 
			o.forEach((e => {
				"all" === t || e.classList.contains(t) ? e.style.display = "" : e.style.display = "none"
			}))
		}))
	}))
}

function updateDesignCounts() {
	const t = document.querySelector(".review");
	if (!t) return;
	const e = t.querySelectorAll(".tab-button"),
		o = t.querySelectorAll(".type_swatch");
	e.forEach((t => {
		const e = t.getAttribute("data-name");
		let a = 0;
		o.forEach((t => {
			("all" === e || t.classList.contains(e)) && a++
		}));
		const n = t.querySelector(".design-count");
		n && (n.textContent = `(${a})`)
	}))
}

function setupTabSwatchClickHandlers() {
	const t = document.querySelector(".review");
	if (!t) return;
	const e = t.querySelectorAll(".tab-swatch"),
		o = t.querySelector(".type-label--selected");
	e.forEach((t => {
		t.addEventListener("click", (function() {
			e.forEach((t => t.classList.remove("active"))), this.classList.add("active");
			const t = this.closest(".m-section-my");
			t && (window.matchMedia("(min-width: 768px)").matches ? t.scrollIntoView({
				behavior: "smooth",
				block: "center"
			}) : t.scrollIntoView({
				behavior: "smooth",
				block: "start"
			}));
			const a = this.getAttribute("data-name");
			localStorage.setItem("designName", a), o && (o.textContent = a)
		}))
	}));
	const a = localStorage.getItem("designName");
	if (a) {
		const t = Array.from(e).find((t => t.getAttribute("data-name") === a));
		t && (t.click(), updateInfopreview())
	} else e.length > 0 && (e[0].click(), updateInfopreview())
}

function findAllCommonProducts() {
	const t = localStorage.getItem("i-wear-product-type"),
		e = localStorage.getItem("partner-wear-product-type"),
		o = localStorage.getItem("i-wear-size-selected"),
		a = localStorage.getItem("partner-wear-size-selected"),
		n = Object.values(allProductsData).flat();
	let r = [];
	n.forEach((n => {
		if (n.shape_style === t || n.shape_style === e)
			for (const c in n.variants) {
				const s = n.variants[c];
				if (n.shape_style === t && s.title === o && s.inventory_quantity > 0 || n.shape_style === e && s.title === a && s.inventory_quantity > 0) {
					r.push(n);
					break
				}
			}
	}));
	const c = [];
	return new Set(r.map((t => t.design_name))).forEach((t => {
		const e = r.filter((e => e.design_name === t));
		e.length > 1 && e.forEach((t => {
			c.some((e => e.product_id === t.product_id)) || c.push(t)
		}))
	})), localStorage.setItem("commonProducts", JSON.stringify(c)), c
}

function updateStepIndicators(t, e) {
	const o = document.querySelector(`${e} .matching-undie_step_conatiner`),
		a = document.querySelector(`${e} .matching-undie_step_conatiner_mobile`);
	o && a && (updateCounter(o, t, !0), updateCounter(a, t, !1))
}

function updateCounter(t, e, o, a) {
	t.querySelectorAll('[class*="matching-undie_steps_"]').forEach(((t, a) => {
		const n = "matching-undie_steps_" + (a + 1);
		o ? t.classList.toggle("active", n <= e) : (t.classList.toggle("active", n === e), t.classList.toggle("hidden", n !== e))
	}))
}

function updateInfopreview() {
	document.querySelectorAll(".review .tab-swatch").forEach((t => {
		t.addEventListener("click", (function() {
			const e = t.getAttribute("data-name"),
				o = t.querySelector("img").getAttribute("src"),
				a = localStorage.getItem("i-wear-size-selected"),
				n = localStorage.getItem("i-wear-product-type"),
				r = localStorage.getItem("partner-wear-size-selected"),
				c = localStorage.getItem("partner-wear-product-type");
			updateInfo(".page-step-1-wapper", ".page-step-1", o, e, a, n), updateInfo(".page-step-2-wapper", ".page-step-2", o, e, r, c);
			let s = parseFloat(searchAndUpdateProductDetails(".page-step-1-wapper", e, n, a, ".page-step-1-info", ".page-step-1", ".page-step-3 .prev_placeholder", ".page-step-1-review-title")) + parseFloat(searchAndUpdateProductDetails(".page-step-2-wapper", e, c, r, ".page-step-2-info", ".page-step-2", ".page-step-3 .prev_placeholder2", ".page-step-2-review-title")),
				i = new Intl.NumberFormat("en-IN", {
					style: "currency",
					currency: "INR",
					minimumFractionDigits: 0
				}).format(s).replace("₹", "RS.");
			const d = document.querySelector("#next-3 .total-price-match");
			d && (d.textContent = i)
		}))
	}))
}

function updateInfo(t, e, o, a, n, r) {
	const c = document.querySelector(t);
	if (c) {
		const t = c.querySelector(`${e}-design`);
		c.querySelector(`${e}-review-title`);
		t && (t.textContent = `${a}, ${n}`)
	}
}

function searchAndUpdateProductDetails(t, e, o, a, n, r, c, s) {
	let i = !1,
		d = 0;
	const l = document.querySelector(t);
	return commonProductsData.forEach((t => {
		if (t.design_name === e && t.shape_style === o) {
			i = !0;
			const e = document.querySelector(n);
			if (e) {
				const a = l.querySelector(".type_icon");
				e.setAttribute("data-productID", t.product_id), e.setAttribute("data-handle", t.product_handle);
				const n = e.querySelector(`${r}-price`),
					i = document.querySelector(c),
					u = document.querySelector(s);
				let p = new Intl.NumberFormat("en-IN", {
					style: "currency",
					currency: "INR",
					minimumFractionDigits: 0
				}).format(t.price);
				p = p.replace("₹", "Rs."), n.textContent = p, i.srcset = t.custom_tool_preview_image, d = t.price, u.textContent = o, a && (a.srcset = t.custom_tool_preview_image)
			}
		}
	})), d
}

function snfWidgetCode(params) {
  let productCode
  let url = window.location.href
  // alert(url)
  let pagestep = false;

  setTimeout(function () {
    // Process all elements with id="matchmen"
    let divs = document.querySelectorAll("#matchmen");
    if (divs.length > 1) {
        divs.forEach((div, index) => {
            // if (index > 0) { // Skip the first element if you want to retain it
                const attributes = Array.from(div.attributes); // Get all attributes as an array
                let foundId = false;

                attributes.forEach(attr => {
                    if (attr.name === "id") {
                        foundId = true; // Mark when "id" is encountered
                    } else if (foundId) {
                        if (attr.name === "style") {
                        // Handle the style attribute explicitly
                        const styleProperties = div.style;
                        if (styleProperties.display) {
                            div.style.display = ""; // Reset the display property
                        }
                      } else {
                          div.removeAttribute(attr.name); // Remove other attributes
                      }
                        // div.removeAttribute(attr.name); // Remove attributes after "id"
                    }
                });

                div.classList.remove('ng-animate-disabled');
                div.innerHTML = "";
            // }
        });
    }

    // Process all elements with id="matchwomen"
    let divsw = document.querySelectorAll("#matchwomen");
    if (divsw.length > 1) {
        divsw.forEach((div, index) => {
            // if (index > 0) { // Skip the first element if you want to retain it
                const attributes = Array.from(div.attributes); // Get all attributes as an array
                let foundId = false;

                attributes.forEach(attr => {
                    if (attr.name === "id") {
                        foundId = true; // Mark when "id" is encountered
                    } else if (foundId) {
                        if (attr.name === "style") {
                        // Handle the style attribute explicitly
                        const styleProperties = div.style;
                        if (styleProperties.display) {
                            div.style.display = ""; // Reset the display property
                        }
                      } else {
                          div.removeAttribute(attr.name); // Remove other attributes
                      }
                        // div.removeAttribute(attr.name); // Remove attributes after "id"
                    }
                });

                div.classList.remove('ng-animate-disabled');
                div.innerHTML = "";
            // }
        });
    }
}, 500);
   
  if (url.includes("?step=partner-wear") && !url.includes("return_url=")) {
    
    pagestep = document.querySelector('.page-step-2');
    
    
  }else if (url.includes("?step=i-wear") && !url.includes("return_url=")){
    pagestep = document.querySelector('.page-step-1');
  }
  setTimeout(function() {
    if(pagestep != false){
      if(params == "men"){ 
        pagestep.querySelector("#matchwomen").removeAttribute("fmf-widget-manager");
        pagestep.querySelector("#matchwomen").style.display="none";
        
        pagestep.querySelector("#matchmen").setAttribute("fmf-widget-manager", "");   
        pagestep.querySelector("#matchmen").style.display="block";  
        productCode = "TC-Men-Underwear"
      }
      if(params == "women"){
        
        pagestep.querySelector("#matchmen").removeAttribute("fmf-widget-manager");
        pagestep.querySelector("#matchmen").style.display="none";
        
        pagestep.querySelector("#matchwomen").setAttribute("fmf-widget-manager", "");   
        pagestep.querySelector("#matchwomen").style.display="block";
        productCode = "TC-Women-Underwear"
      }
          
      if (productCode) {
          let productDiv = pagestep.querySelector('[fmf-widget-manager]');
          if (productDiv) {
            productDiv.setAttribute('product-code', productCode);
          }
      }
      loadScript();
    }else{
      let newpagestep = "";
      if(url.includes("?step=i-wear") && url.includes("return_url=")){
        
            newpagestep = document.querySelector('.page-step-1');
          
            if(params == "men"){ 
            newpagestep.querySelector("#matchwomen").removeAttribute("fmf-widget-manager");
            // newpagestep.querySelector("#matchwomen").style.display="none";
            
            newpagestep.querySelector("#matchmen").setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector("#matchmen").style.display="block";  
            productCode = "TC-Men-Underwear"
          }
          if(params == "women"){
            
            newpagestep.querySelector("#matchmen").removeAttribute("fmf-widget-manager");
            // newpagestep.querySelector("matchmen").style.display="none";
            
            newpagestep.querySelector("#matchwomen").setAttribute("fmf-widget-manager", "");   
            newpagestep.querySelector("#matchwomen").style.display="block";
            productCode = "TC-Women-Underwear"
          }
              
          if (productCode) {
              let productDiv = newpagestep.querySelector('[fmf-widget-manager]');
              if (productDiv) {
                productDiv.setAttribute('product-code', productCode);
              }
          }
        }else if(url.includes("?step=partner-wear") && url.includes("return_url=")){
          newpagestep = document.querySelector('.page-step-2');
          
          if(params == "men"){ 
          newpagestep.querySelector("#matchwomen").removeAttribute("fmf-widget-manager");
          // newpagestep.querySelector("#matchwomen").style.display="none";
          
          newpagestep.querySelector("#matchmen").setAttribute("fmf-widget-manager", "");   
          newpagestep.querySelector("#matchmen").style.display="block";  
          productCode = "TC-Men-Underwear"
        }
        if(params == "women"){
          
          newpagestep.querySelector("#matchmen").removeAttribute("fmf-widget-manager");
          // newpagestep.querySelector("#matchmen").style.display="none";
          
          newpagestep.querySelector("#matchwomen").setAttribute("fmf-widget-manager", "");   
          newpagestep.querySelector("#matchwomen").style.display="block";
          productCode = "TC-Women-Underwear"
        }
            
        if (productCode) {
            let productDiv = newpagestep.querySelector('[fmf-widget-manager]');
            if (productDiv) {
              productDiv.setAttribute('product-code', productCode);
            }
        }
      }
      
      loadScript();
    }
    
  },550);
}

function loadScript() {
	let scripts = [
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/runtime.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/polyfills.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/scripts.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/main.js"
	];

	scripts.forEach(function(src) {
		let script = document.createElement('script');
		script.src = src;
		script.async = true; // Load script asynchronously
		document.body.appendChild(script);
	});
}



function handleSectionActions(t) {
  
	const e = document.querySelector(t);
  
	let o = e.getAttribute("data-step");
	if (!e) return;
	const a = e.querySelectorAll(".m-richtext__button_outter .m-richtext__button[data-open]"),
		n = e.querySelectorAll(".size-chart-pop"),
		r = e.querySelector(".tab-component"),
		c = e.querySelector("div[data-variant-picker]"),
		s = e.querySelector(".m-sticky-addtocart"),
		i = e.querySelectorAll('.m-product-option--node input[type="radio"]'),
		d = e.querySelector("img.prev_placeholder"),
		l = document.querySelector(".page-step-1-review-title"),
		u = document.querySelector(".page-step-2-review-title"),
        pagestepnextiwear = document.querySelector("[data-redirect='page-step-1']"),
        pagestepnextpartnerwear = document.querySelector("[data-redirect='page-step-2']"),
        nextbtniwear =  document.querySelector(".page-step-1 .m-sticky-addtocart"),
        nextbtnpartnerwear =  document.querySelector(".page-step-2 .m-sticky-addtocart");
  
	"bra" !== o && "underwear" !== o || r.classList.remove("hidden"), a.forEach((i => {
		i.addEventListener("click", (function() {
          
			const d = i.getAttribute("data-open");
          
            // window.alert("snf"+d)
            // document.getElementById("snfid"+d).textContent = "Hello!"+d;
            setTimeout(function() {
              snfWidgetCode(d);
            }, 500); // 5 seconds delay
            // Load the scripts after a delay
            setTimeout(loadScript, 500); // 3 seconds delay
			a.forEach((t => t.classList.remove("active"))), i.classList.add("active"), s.classList.add("hidden"), r.classList.remove("hidden"),
				function sizeTabDisplay(t) {
					n.forEach((t => t.classList.add("hidden")));
					const e = Array.from(n).find((e => e.getAttribute("data-open") === t));
					e && e.classList.remove("hidden")
				}(d), c.classList.add("hidden"),
				function updateTabDisplay(t) {
					const o = e.querySelectorAll(".type_button");
					o.forEach((e => {
						e.classList.contains(t) ? e.classList.remove("hidden") : e.classList.add("hidden")
					}))
				}(d), ".page-step-1" == t && (l.innerHTML = d, updateStepIndicators("matching-undie_steps_2", ".page-step-1")), ".page-step-2" == t && (u.innerHTML = d, updateStepIndicators("matching-undie_steps_5", ".page-step-2")), localStorage.setItem(`${o}-match-type`, d), updateStepIndicators(2);
			const p = i.closest(".m-section-my");
			p && (window.matchMedia("(min-width: 768px)").matches ? p.scrollIntoView({
				behavior: "smooth",
				block: "center"
			}) : p.scrollIntoView({
				behavior: "smooth",
				block: "end"
			}))
		}))
	}));
	const p = e.querySelectorAll(".type_button button");
	p.forEach((a => {
		a.addEventListener("click", (function() {
			p.forEach((t => t.classList.remove("active"))), a.classList.add("active");
			const n = a.getAttribute("data-prev-img"),
				r = a.getAttribute("data-collection"),
				s = a.closest(".type_button").querySelector(".type_product_data"),
				i = a.getAttribute("data-name"),
				l = a.closest(".type_button");
			let u = "";
			s && (u = localStorage.getItem(i)), n && d && (d.src = n, d.srcset = n), c.classList.remove("hidden"),
				function updateSizesDisplay(t) {
					if (!t) return;
					const o = e.querySelector(".sizes-all");
					if (!o) return;
					const a = Array.from(o.querySelectorAll(".m-product-option--node")),
						n = Array.from(t.classList);
					a.forEach((t => {
						const e = t.getAttribute("data-value");
						n.includes(e.toLowerCase()) ? t.classList.remove("hidden") : t.classList.add("hidden")
					}))
				}(l),
				function allProduct(t) {
					try {
						decodeURIComponent(t);
						const e = JSON.parse(t);
						allProductsData[`allProduct-${o}`] = e
					} catch (t) {}
				}(u), localStorage.setItem(`${o}-product-type`, i), localStorage.setItem(`${o}-collection`, r), ".page-step-1" == t && updateStepIndicators("matching-undie_steps_3", ".page-step-1"), ".page-step-2" == t && updateStepIndicators("matching-undie_steps_6", ".page-step-2");
			const m = a.closest(".m-section-my");
			m && (window.matchMedia("(min-width: 768px)").matches ? m.scrollIntoView({
				behavior: "smooth",
				block: "center"
			}) : m.scrollIntoView({
				behavior: "smooth",
				block: "end"
			})), updateStepIndicators(3)
		}))
	})), i.forEach((t => {
		t.addEventListener("change", (function() {
            this.checked && (s.classList.remove("hidden"), localStorage.setItem(`${o}-size-selected`, this.value))
			// this.checked && (s.classList.remove("hidden"), localStorage.setItem(`${o}-size-selected`, this.value), updateStepCounter())
		}))
	})), document.addEventListener("DOMContentLoaded", (function() {
		const t = new URLSearchParams(window.location.search).get("callback");
		t && window[t] && "function" == typeof window[t] && window[t]()
	}))

    pagestepnextiwear.addEventListener("click", (function() {
        updateiwearscript();
    }));
    pagestepnextpartnerwear.addEventListener("click", (function() {
      updatepartnerwearscript();
    }));

    nextbtniwear.addEventListener("click", (function() {
        updateiwearscriptfromnextbtn();
    }));
    // nextbtnpartnerwear.addEventListener("click", (function() {
    //   updatepartnerwearscriptfromnextbtn();
    // }));
}

function updateiwearscriptfromnextbtn() {
  let url = window.location.href;

  if (url.includes("?step=i-wear")){
    updatepartnerwearscript();
  }
}
function updateiwearscript() {
  setTimeout(function() {
      let divs = document.querySelector(".page-step-2 #matchmen");
      if (divs) {
          const attributes = Array.from(divs.attributes); // Get all attributes as an array
            let foundId = false;
        
            attributes.forEach(attr => {
              if (attr.name === "id") {
                foundId = true; // Mark when "id" is encountered
              } else if (foundId) {
                divs.removeAttribute(attr.name); // Remove attributes after "id"
              }
            });
          divs.classList.remove('ng-animate-disabled');
          divs.innerHTML = "";
      }   
      let divsw = document.querySelector(".page-step-2 #matchwomen");
      if (divsw) {   
          const attributes = Array.from(divsw.attributes); // Get all attributes as an array
            let foundId = false;
        
            attributes.forEach(attr => {
              if (attr.name === "id") {
                foundId = true; // Mark when "id" is encountered
              } else if (foundId) {
                divsw.removeAttribute(attr.name); // Remove attributes after "id"
              }
            });
          divsw.classList.remove('ng-animate-disabled');
          divsw.innerHTML = "";   
      }
    }, 100);
    setTimeout(function() {
      let steponesection = document.querySelector(".page-step-1");
      let dataoption = steponesection.querySelector('.m-richtext__button_outter .m-richtext__button.active');
          dataoption = dataoption.getAttribute('data-open');
      
      if(dataoption == "men"){ 
          steponesection.querySelector("#matchwomen").removeAttribute("fmf-widget-manager");
          steponesection.querySelector("#matchwomen").style.display="none";
          
          steponesection.querySelector("#matchmen").setAttribute("fmf-widget-manager", "");   
          steponesection.querySelector("#matchmen").style.display="block";  
          productCode = "TC-Men-Underwear"
        }
        if(dataoption == "women"){
          
          steponesection.querySelector("#matchmen").removeAttribute("fmf-widget-manager");
          steponesection.querySelector("#matchmen").style.display="none";
          
          steponesection.querySelector("#matchwomen").setAttribute("fmf-widget-manager", "");   
          steponesection.querySelector("#matchwomen").style.display="block";
          productCode = "TC-Women-Underwear"
        }
            
        if (productCode) {
            let productDiv = steponesection.querySelector('[fmf-widget-manager]');
            if (productDiv) {
              productDiv.setAttribute('product-code', productCode);
            }
        }
      loadScript();
    }, 150);
}

function updatepartnerwearscript() {
   setTimeout(function() {
      let divs = document.querySelector(".page-step-1 #matchmen");
      if (divs) {
          const attributes = Array.from(divs.attributes); // Get all attributes as an array
            let foundId = false;
        
            attributes.forEach(attr => {
              if (attr.name === "id") {
                foundId = true; // Mark when "id" is encountered
              } else if (foundId) {
                divs.removeAttribute(attr.name); // Remove attributes after "id"
              }
            });
          divs.classList.remove('ng-animate-disabled');
          divs.innerHTML = "";
      }   
      let divsw = document.querySelector(".page-step-1 #matchwomen");
      if (divsw) {   
          const attributes = Array.from(divsw.attributes); // Get all attributes as an array
            let foundId = false;
        
            attributes.forEach(attr => {
              if (attr.name === "id") {
                foundId = true; // Mark when "id" is encountered
              } else if (foundId) {
                divsw.removeAttribute(attr.name); // Remove attributes after "id"
              }
            });
          divsw.classList.remove('ng-animate-disabled');
          divsw.innerHTML = "";   
      }
    }, 100);
  setTimeout(function() {
      let steponesection = document.querySelector(".page-step-2");
      let dataoption = steponesection.querySelector('.m-richtext__button_outter .m-richtext__button.active');
          dataoption = dataoption.getAttribute('data-open');
      
      if(dataoption == "men"){ 
          steponesection.querySelector("#matchwomen").removeAttribute("fmf-widget-manager");
          steponesection.querySelector("#matchwomen").style.display="none";
          
          steponesection.querySelector("#matchmen").setAttribute("fmf-widget-manager", "");   
          steponesection.querySelector("#matchmen").style.display="block";  
          productCode = "TC-Men-Underwear"
        }
        if(dataoption == "women"){
          
          steponesection.querySelector("#matchmen").removeAttribute("fmf-widget-manager");
          steponesection.querySelector("#matchmen").style.display="none";
          
          steponesection.querySelector("#matchwomen").setAttribute("fmf-widget-manager", "");   
          steponesection.querySelector("#matchwomen").style.display="block";
          productCode = "TC-Women-Underwear"
        }
            
        if (productCode) {
            let productDiv = steponesection.querySelector('[fmf-widget-manager]');
            if (productDiv) {
              productDiv.setAttribute('product-code', productCode);
            }
        }
      loadScript();
    }, 150);
}
function updateStepAndStorage(t) {
	const e = new URL(window.location.href);
	e.searchParams.set("step", t), history.pushState({}, "", e), localStorage.setItem("current-step", t), showAppropriateStep()
}

function fetchProductVariantIdByHandle(t, e) {
	const o = localStorage.getItem("commonProducts");
	if (!o) return null;
	const a = JSON.parse(o);
	if (!Array.isArray(a)) return null;
	let n = null,
		r = null;
	for (const o of a) {
		if (o.product_handle === t)
			for (const t in o.variants) {
				const a = o.variants[t];
				if (a.title === e) {
					n = t, r = a.inventory_quantity;
					break
				}
			}
		if (null !== n) break
	}
	return null !== n ? {
		variantId: n,
		inventory: r
	} : null
}
async function addProductsToCart(t, e, o, a) {
	try {
		const n = await fetchProductVariantIdByHandle(t, o),
			r = await fetchProductVariantIdByHandle(e, a);
		let c = [];
		if (n && n.inventory > 0 && c.push({
				id: n.variantId,
				quantity: 1,
				properties: {
					comboType: "Matching Undie"
				}
			}), r && r.inventory > 0 && c.push({
				id: r.variantId,
				quantity: 1,
				properties: {
					comboType: "Matching Undie"
				}
			}), 2 === c.length) {
			const t = {
					items: c
				},
				e = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify(t)
				});
			if (!e.ok) throw new Error("Failed to add items to the cart.");
			const o = await e.json();
			if (window.MinimogSettings && window.MinimogSettings.use_ajax_atc) {
				updateCartUI(), window.MinimogSettings.enable_cart_drawer ? window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer) : window.MinimogTheme.Notification.show({
					target: document.body,
					method: "appendChild",
					type: "success",
					message: "Items added to cart",
					last: 3e3,
					sticky: !1
				});
				document.getElementById("MinimogCartDrawer").classList.add("m-cart-drawer--active"), window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, o)
			} else window.location = window.MinimogSettings.routes.cart
		}
	} catch (t) {}
}
async function updateCartUI() {
	await updateCartSection("/cart?section_id=cart-template", "[data-minimog-cart-items]", "[data-cart-subtotal]", "[data-minimog-cart-discounts]", "[data-minimog-gift-wrapping]"), await updateCartSection("/cart?section_id=cart-drawer", "[data-minimog-cart-items]", "[data-cart-subtotal]", "[data-minimog-cart-discounts]", "[data-minimog-gift-wrapping]");
	const t = await fetch("/cart.js").then((t => t.json())),
		e = document.getElementById("MinimogCartDrawer");
	e && e.classList.remove("m-cart--empty"), updateCartCount(t.item_count), openCartDrawer()
}
async function updateCartSection(t, e, o, a, n) {
	try {
		const r = await fetch(t),
			c = await r.text(),
			s = (new DOMParser).parseFromString(c, "text/html"),
			i = s.querySelector(e).innerHTML;
		document.querySelectorAll(e).forEach((t => t.innerHTML = i));
		const d = s.querySelector(o).innerHTML;
		document.querySelectorAll(o).forEach((t => t.innerHTML = d));
		const l = s.querySelector(a).innerHTML;
		document.querySelectorAll(a).forEach((t => t.innerHTML = l));
		const u = s.querySelector(n).innerHTML;
		document.querySelectorAll(n).forEach((t => t.innerHTML = u))
	} catch (t) {}
}

function updateCartCount(t) {
	document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
		t > 0 ? (e.textContent = t, e.classList.remove("hidden")) : e.classList.add("hidden")
	}))
}

function updateGlobalCartCount(t) {
	document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
		t > 0 ? (e.textContent = t, e.classList.remove("m:hidden")) : (e.textContent = "", e.classList.add("m:hidden"))
	}))
}

function openCartDrawer(t) {
	const e = document.querySelector(".m-cart-drawer"),
		o = document.querySelector(".m-cart-drawer__inner");
	e && o && (t && setActiveElement(t), e.classList.add("m-cart-drawer--active"), e.classList.remove("m-cart--empty"), requestAnimationFrame((() => {
		document.documentElement.style.setProperty("--m-bg-opacity", "0.5"), o.style.setProperty("--translate-x", "0")
	})), window.MinimogEvents && MinimogTheme && MinimogTheme.pubSubEvents && window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer))
}
async function fetchLatestCartCount() {
	return new Promise((t => {
		t(parseInt(localStorage.getItem("cartItemCount"), 10) || 0)
	}))
}

function updateCartCount(t) {
	document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
		t > 0 ? (e.textContent = t, e.classList.remove("hidden")) : e.classList.add("hidden")
	}))
}
showAppropriateStep(), window.onpopstate = function(t) {
	showAppropriateStep()
}, document.addEventListener("DOMContentLoaded", (() => {
	handleSectionActions(".page-step-1"), handleSectionActions(".page-step-2");
	const t = document.querySelector(".next-1"),
		e = document.querySelector(".next-2"),
		o = document.querySelector(".modify-1"),
		a = document.querySelector(".modify-2"),
		n = document.querySelector("#next-3"),
		r = document.querySelector(".page-step-1"),
		c = document.querySelector(".page-step-2"),
		s = document.querySelector(".page-step-3");
	localStorage.getItem("modify");

	function appendColorSelectQueryParam() {
		const t = new URL(window.location.href);
		t.searchParams.set("return_url", "color-select"), window.history.pushState({}, "", t)
	}
	t && r && c && t.addEventListener("click", (function() {
		const t = c.getAttribute("data-step");
		r.classList.add("hidden"), c.classList.remove("hidden"), updateStepAndStorage(t)
	})), e && c && s && e.addEventListener("click", (function() {
		const t = s.getAttribute("data-step");
		c.classList.add("hidden"), s.classList.remove("hidden"), updateStepAndStorage(t), showAppropriateStep()
	})), o && r && s && o.addEventListener("click", (function() {
		const t = r.getAttribute("data-step");
		s.classList.add("hidden"), r.classList.remove("hidden"), updateStepAndStorage(t), appendColorSelectQueryParam(), localStorage.setItem("modify", "yes")
	})), a && s && c && a.addEventListener("click", (function() {
		const t = c.getAttribute("data-step");
		s.classList.add("hidden"), c.classList.remove("hidden"), updateStepAndStorage(t), localStorage.setItem("modify", "yes")
	})), n && s && n.addEventListener("click", (function() {
		const t = document.querySelector(".page-step-1-info").getAttribute("data-handle"),
			e = document.querySelector(".page-step-2-info").getAttribute("data-handle"),
			o = localStorage.getItem("i-wear-size-selected"),
			a = localStorage.getItem("partner-wear-size-selected");
		t && e && o && a && addProductsToCart(t, e, o, a).then((function() {})).catch((function(t) {}))
	}))
  window.addEventListener("popstate", handleUrlChange);
  window.addEventListener("hashchange", handleUrlChange);
}));

function updateUrlParameters(newParams) {
    const url = new URL(window.location.href);
    for (const [key, value] of Object.entries(newParams)) {
        url.searchParams.set(key, value);
    }
    window.history.replaceState({}, '', url);
}

function handleUrlChange() {
    const url = new URL(window.location.href);

    if (url.searchParams.get("step") === "color-select") {
        const returnUrl = url.searchParams.get("return_url");
        const pageStepDiv = document.querySelector(".page-step-1");

        if (pageStepDiv && !pageStepDiv.classList.contains("hidden")) {
            if (returnUrl) {
                updateUrlParameters({ step: "i-wear", return_url: "color-select" });
            } else {
                updateUrlParameters({ step: "i-wear" });
            }
          updateiwearscript();
        }
      const designName = localStorage.getItem("designName");

      if (designName) {
          const tabSwatchButtons = document.querySelectorAll(".tab-swatch");
  
          let matchFound = false;
  
          tabSwatchButtons.forEach((button) => {
              const dataName = button.getAttribute("data-name");
  
              if (dataName === designName) {
                  matchFound = true;
              }
          });
  
          if (!matchFound && tabSwatchButtons.length > 0) {
              tabSwatchButtons[0].click();
          }
      }
    }
}